module.exports = __webpack_public_path__ + "static/media/arrowRightWhite.70982270.svg";